export const CASE_CARD_MODAL_BODY_CLASS = "flex w-full flex-col gap-8"
export const CASE_CARD_MODAL_PARAGRAPH_CLASS =
  "text-base flex flex-col gap-2 leading-[normal] text-[var(--ds-text-primary)] break-words [&_strong]:font-semibold"
export const CASE_CARD_MODAL_SECTION_CLASS = "flex w-full flex-col gap-2"
export const CASE_CARD_MODAL_SECTION_TITLE_CLASS =
  "text-base font-semibold leading-normal text-[var(--ds-text-primary)]"
export const CASE_CARD_MODAL_BADGE_LIST_CLASS = "flex w-full flex-wrap gap-2"
export const CASE_CARD_MODAL_BADGE_LIST_ITEM_CLASS = "list-none"
export const CASE_CARD_MODAL_BADGE_CLASS = "whitespace-normal break-words"
export const CASE_CARD_MODAL_LIST_CLASS = "flex w-full list-none flex-col gap-2 p-0"
export const CASE_CARD_MODAL_LIST_ITEM_CLASS = "flex items-center gap-2"
export const CASE_CARD_MODAL_LIST_BULLET_CLASS = "size-1.5 shrink-0 rounded-full bg-[var(--ds-links-default)]"
export const CASE_CARD_MODAL_LIST_TEXT_CLASS =
  "text-base leading-[normal] text-[var(--ds-text-primary)] break-words"
